// extracted by mini-css-extract-plugin
var _1 = "TablePagination_root__f0595";
export { _1 as "root" }
